import script from "./HeadPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadPhone.vue?vue&type=script&setup=true&lang=js"

import "./HeadPhone.vue?vue&type=style&index=0&id=057edb66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057edb66"]])

export default __exports__